var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "description text-uppercase" },
    [
      _vm.recommendedAccessory
        ? _c("strong", [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$resourceString["product.detail.recommended.weldrods"]
                ) +
                "\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.recommendedAccessory
        ? _c("ul", { staticClass: "list-unstyled" }, [
            _c("li", { staticClass: "weldrods" }, [
              _c(
                "a",
                {
                  attrs: { href: "javascript:void(0)" },
                  on: { click: _vm.openWeldrodsModal }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.formatAccessory(_vm.recommendedAccessory)) +
                      "\n      "
                  )
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            height: "560",
            name: "recommended-weldrods-modal",
            "data-html2canvas-ignore": "true",
            adaptive: true,
            scrollable: true
          }
        },
        [
          _c("pc-product-weldrods-modal", {
            attrs: { recommendedAccessory: _vm.recommendedAccessory }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }